var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feature__item",class:[
    !_vm.teaser
      ? ("w-1/2 md:w-1/" + _vm.perRow + " lg:w-1/" + _vm.perRow + " h-12 md:h-20")
      : !_vm.single
      ? 'w-1/2 border-b h-12'
      : 'w-full border-b'
  ]},[_c('div',{staticClass:"text-3xl flex-initial p-2",class:("text-" + _vm.color + "-primary")},[_vm._t("icon")],2),_c('div',{staticClass:"flex-1 p-2 text-xs lg:text-sm"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }